import { NavLink } from "react-router-dom";
import routeUrls from "../COMPONENTS/navbar/navLink";
import { usePageBackground } from "../COMPONENTS/usePageBackground";
import { useAuth } from "../FIREBASE/useAuth";
import "../CSS/projekt.scss";

interface Tool {
  to: string;
  title: string;
  desc: string;
  login?: boolean; // only shown to signed-in visitors; the page needs an account
}

const TOOLS: Tool[] = [
  {
    to: routeUrls.TODO,
    login: true,
    title: "Att göra",
    desc: "En enkel att göra-lista med deadlines och prioritet.",
  },
  {
    to: routeUrls.FOOD,
    login: true,
    title: "Veckomatsedel",
    desc: "Förslag på veckans middagar och en automatisk inköpslista.",
  },
  {
    to: routeUrls.BOOKS,
    login: true,
    title: "Böcker",
    desc: "Koll på lästa böcker — med import från Goodreads.",
  },
  {
    to: routeUrls.BIKES,
    login: true,
    title: "Prylar",
    desc: "Överblick över delar och komponenter på dina prylar.",
  },
  {
    to: routeUrls.HEM,
    login: true,
    title: "Hem",
    desc: "Planritning över hemmet i 2D och 3D — vitvaror, lampor och när de senast byttes.",
  },
  {
    to: routeUrls.LIFTS,
    login: true,
    title: "Träningslogg",
    desc: "Vikt per övning över tid — rekord, kurva och skivor per sida.",
  },
  {
    to: routeUrls.ROLLERSKI,
    login: true,
    title: "Rullskidor",
    desc: "Sätt waypoints och hitta asfaltrutter utan för branta nedförsbackar.",
  },
  {
    to: routeUrls.SKIGAME,
    title: "Rullskidspel",
    desc: "Pixligt 3D-spel: åk rullskidor genom Stockholm mot trafiken så långt du kan.",
  },
  {
    to: routeUrls.MEKPORTAL,
    login: true,
    title: "Maskiningenjör",
    desc: "Lärportal: det en maskiningenjör behöver kunna, med formler, självtest och resurser.",
  },
  {
    to: routeUrls.TRADERA,
    login: true,
    title: "Tradera",
    desc: "Bevaka sökningar på Tradera — nya annonser markeras när du öppnar sidan.",
  },
];

export const ProjektHubView = () => {
  usePageBackground();
  const { user } = useAuth();
  const tools = TOOLS.filter((t) => !t.login || user);

  return (
    <div className="projekt">
      <div className="projekt__inner">
        <header className="projekt__header">
          <NavLink to={routeUrls.HOME} className="projekt__back">← Hem</NavLink>
          <h1 className="projekt__title">Projekt<span className="projekt__dot">.</span></h1>
          <p className="projekt__sub">Egna verktyg och webbappar.</p>
        </header>

        <div className="projekt__list">
          {tools.map((t) => (
            <NavLink key={t.to} to={t.to} className="projekt__item">
              <span className="projekt__item-title">{t.title}</span>
              <span className="projekt__item-desc">{t.desc}</span>
              <span className="projekt__item-arrow" aria-hidden="true">→</span>
            </NavLink>
          ))}
        </div>
      </div>
    </div>
  );
};
